<template>
  <div class="ft-card" style="max-width:760px;">
    <div class="ft-card-header-row">
      <h3 class="ft-card-title">
        <i class="fas" :class="isEdit ? 'fa-pencil-alt' : 'fa-plus-square'"></i>
        {{ isEdit ? 'Edit Job Opening' : 'New Job Opening' }}
      </h3>
    </div>

    <form @submit.prevent="save">
      <div class="ft-field-row">
        <label class="ft-field-label">Position</label>
        <input type="text" v-model="form.position" required>
        <div class="ft-error-text" v-if="errors.position">{{ errors.position[0] }}</div>
      </div>

      <div style="display:flex; gap:16px; flex-wrap:wrap;">
        <div class="ft-field-row" style="flex:1; min-width:200px;">
          <label class="ft-field-label">Department</label>
          <input type="text" v-model="form.department">
        </div>
        <div class="ft-field-row" style="flex:1; min-width:200px;">
          <label class="ft-field-label">Level</label>
          <input type="text" v-model="form.level" placeholder="e.g. Junior, Supervisor, Leader">
        </div>
        <div class="ft-field-row" style="flex:1; min-width:200px;">
          <label class="ft-field-label">Location</label>
          <input type="text" v-model="form.location">
        </div>
      </div>

      <div class="ft-field-row">
        <label class="ft-field-label">Job Description</label>
        <textarea v-model="form.job_description" rows="4"></textarea>
      </div>

      <div class="ft-field-row">
        <label class="ft-field-label">Responsibilities</label>
        <textarea v-model="form.responsibilities" rows="4"></textarea>
      </div>

      <div class="ft-field-row">
        <label class="ft-field-label">Requirements</label>
        <textarea v-model="form.requirements" rows="4"></textarea>
      </div>

      <div class="ft-field-row" style="max-width:220px;">
        <label class="ft-field-label">Status</label>
        <select v-model="form.status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div class="ft-action-cell">
        <button type="submit" class="ft-btn" :disabled="saving">
          <i class="fas fa-spinner fa-spin" v-if="saving"></i>
          <i class="fas fa-check" v-else></i>
          {{ saving ? 'Saving...' : (isEdit ? 'Update Opening' : 'Create Opening') }}
        </button>
        <router-link to="/admin/careers" class="ft-btn ft-btn-outline"><i class="fas fa-times"></i> Cancel</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import career from '@/services/adminCareer.service';

export default {
  name: 'AdminCareerForm',
  data() {
    return {
      form: {
        position: '',
        department: '',
        level: '',
        location: '',
        job_description: '',
        responsibilities: '',
        requirements: '',
        status: 'active',
      },
      errors: {},
      saving: false,
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  mounted() {
    if (this.isEdit) {
      career.show(this.$route.params.id).then((response) => {
        const row = response.data.data;
        this.form = {
          position: row.position,
          department: row.department || '',
          level: row.level || '',
          location: row.location || '',
          job_description: row.job_description || '',
          responsibilities: row.responsibilities || '',
          requirements: row.requirements || '',
          status: row.status,
        };
      });
    }
  },
  methods: {
    save() {
      this.saving = true;
      this.errors = {};

      const request = this.isEdit
        ? career.update(this.$route.params.id, this.form)
        : career.create(this.form);

      request.then(() => {
        this.$router.push('/admin/careers');
      }).catch((err) => {
        if (err.response && err.response.status === 422) {
          this.errors = err.response.data.errors;
        }
      }).finally(() => {
        this.saving = false;
      });
    },
  },
};
</script>
